import { useState } from "react";
import { Save } from "lucide-react";
import { updateCourse } from "../services/course.service";
import { useCourse } from "../context/CourseContext";
import toast from "react-hot-toast";
import { cn } from "../lib/utils";

const extractCourseIdFromPath = () => {
  const path = window.location.pathname;
  const match = path.match(/\/course\/([^/]+)/);
  return match ? match[1] : null;
};

const SaveButton = ({ urlId, className = "" }) => {
  const {
    courseData,
    setCourseData,
    markSessionsAsSaved,
    resetPendingChanges,
  } = useCourse();
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    const courseId = urlId || extractCourseIdFromPath();

    if (!courseId) {
      toast.error("No course ID found");
      return;
    }

    try {
      setIsSaving(true);

      const updatedCourse = await updateCourse(courseId, courseData);

      setCourseData({ ...updatedCourse, students: courseData.students });

      const sessionsArr = Array.isArray(updatedCourse.attendance?.sessions)
        ? updatedCourse.attendance.sessions
        : [];
      const savedSessionKeys = sessionsArr.map((s) => {
        const dateStr = (s.date || "").includes("T")
          ? s.date.split("T")[0]
          : s.date;
        return `${dateStr}_${s.time || ""}_${s.branch || ""}`;
      });
      markSessionsAsSaved(savedSessionKeys);

      resetPendingChanges();

      toast.success("Course saved successfully!");
    } catch (error) {
      console.error("Error saving course:", error);
      toast.error("Failed to save course");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <button
      onClick={handleSave}
      disabled={isSaving}
      className={cn(
        "flex items-center gap-2 bg-accent1 hover:bg-accent1/90 text-white py-2 px-4 rounded-sm transition-colors my-4 text-sm font-medium",
        isSaving && "opacity-70 cursor-not-allowed",
        className
      )}
    >
      <Save className={cn("h-4 w-4", isSaving && "animate-spin")} />
      {isSaving ? (
        <span>Saving...</span>
      ) : (
        <>
          <span className="hidden sm:inline">Save Changes</span>
          <span className="sm:hidden">Save</span>
        </>
      )}
    </button>
  );
};

export default SaveButton;
